export enum BookingState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  BOOKED = 'BOOKED',
  TO_BE_CANCELLED = 'TO_BE_CANCELLED',
  CANCELLED = 'CANCELLED',
  APPROVED = 'APPROVED',
  AUTOMATICALLY_APPROVED = 'AUTOMATICALLY_APPROVED',
  UPGRADED = 'UPGRADED',
  ENDED = 'ENDED',
}

export const ActiveBookingStates = [BookingState.BOOKED, BookingState.TO_BE_CANCELLED];
export const RequestedBookingStates = [BookingState.ACCEPTED, BookingState.PENDING];
export const ActiveOrRequestedBookingStates = [...ActiveBookingStates, ...RequestedBookingStates];
